import { actions } from "./action-list";

export function operatorsFetched(value) {
  return {
    type: actions.FETCH_OPERATORS,
    value,
  };
}
export function fetchCityOperator(value) {
  return {
    type: actions.CITY_OPERATORS,
    value,
  };
}
export function selectedOperator(value) {
  return {
    type: actions.SELECTED_OPERATOR,
    value,
  };
}
